// Tracks where in the plan body a glossary link was last clicked from, so the
// Full Plan PDF glossary appendix can offer a "back to your place" link that
// returns the reader to the exact spot they jumped from.

let lastOrigin = null; // { slug, el }

export function setGlossaryOrigin(slug, el) {
  if (slug && el) lastOrigin = { slug, el };
}

// Scroll back to the reader's place for `slug`. Prefers the exact element they
// clicked (if still mounted); otherwise falls back to the first occurrence of
// that term in the plan body. Returns true when it found somewhere to go.
export function scrollBackToOrigin(slug) {
  if (
    lastOrigin &&
    lastOrigin.slug === slug &&
    lastOrigin.el &&
    typeof document !== "undefined" &&
    document.contains(lastOrigin.el)
  ) {
    lastOrigin.el.scrollIntoView({ behavior: "smooth", block: "center" });
    return true;
  }
  if (typeof document !== "undefined") {
    const first = document.querySelector(`[data-glossary-slug="${slug}"]`);
    if (first) {
      first.scrollIntoView({ behavior: "smooth", block: "center" });
      return true;
    }
  }
  return false;
}
